import React from 'react';
import { Link } from 'react-router-dom';
import { Wordmark } from '../brand/Wordmark';
import { NewTabHint } from '../ui/NewTabHint';
import { Reveal } from '../motion/Reveal';
import { DoodleScatter } from '../brand/DoodleScatter';
import { brandDescriptor } from '../../data/brandAssets';
import { allRoutes, emailAddress, externalLinks } from '../../data/site';
const connectLinks = [{
  label: 'Instagram',
  href: externalLinks.instagram
}, {
  label: 'Discord',
  href: externalLinks.discord
}, {
  label: 'KnightConnect',
  href: externalLinks.knightConnect
}, {
  label: 'Photo Album',
  href: externalLinks.photoAlbum
}, {
  label: 'Get Connected Form',
  href: externalLinks.getConnectedForm
}];
export function Footer() {
  const year = new Date().getFullYear();
  return <footer className="on-dark relative w-full overflow-hidden bg-brand-navy text-white" data-id="element-227" data-mp="3e2w6c5lui5rr">
      {/* Navy surface: scatter uses cream, yellow, and light blue only. */}
      <DoodleScatter tone="navy" seed="site-footer" data-id="element-228" data-mp="394kwvvzgpxa2" />
      <div className="relative mx-auto w-full max-w-6xl px-5 py-14 sm:px-8" data-id="element-229" data-mp="2kcl3h90pilw6">
        <Reveal data-id="element-230" data-mp="2p3tf8bpiejci">
          <div className="grid gap-10 sm:grid-cols-2 sm:gap-12 lg:grid-cols-[1.4fr_1fr_1fr]" data-id="element-231" data-mp="2p4cypwut5fsn">
            <div data-id="element-232" data-mp="2bcydrkhcb4iy">
              {/* Supplied artwork on a light brand plate — never recolored. */}
              <Link to="/" aria-label={`UCF BCM — ${brandDescriptor} — home`} data-id="element-233" data-mp="2gazvo2314xsu">
                <Wordmark onDark className="h-8" data-id="element-234" data-mp="3413yi78e8tis" />
              </Link>
              <p className="mt-4 font-meta text-[12px] font-medium uppercase tracking-[0.16em] text-brand-blue" data-id="element-235" data-mp="341vi0jopv0sp">
                {brandDescriptor}
              </p>
              <p className="mt-3 max-w-sm font-sans text-[15px] leading-relaxed text-white" data-id="element-236" data-mp="2u1uwcr3dk8lc">
                A Christian community for college students at UCF and surrounding campuses.
              </p>
              <p className="mt-4 font-meta text-[13px] font-medium text-brand-yellow" data-id="element-237" data-mp="1impqje7y5txi">
                Thursdays at 7:30 PM
              </p>
              <a href={externalLinks.email} className="mt-2 inline-block font-meta text-[13px] text-white underline underline-offset-4 hover:text-brand-yellow" data-id="element-238" data-mp="1nkras2h3zzak">
                {emailAddress}
              </a>
            </div>

            <nav aria-label="Footer site links" data-id="element-239" data-mp="uqusuhcaqho8">
              <h2 className="font-meta text-xs font-semibold uppercase tracking-[0.18em] text-brand-blue" data-id="element-240" data-mp="ptkugc6xivo9">
                Explore
              </h2>
              <ul className="mt-4 space-y-3" data-id="element-241" data-mp="kvt3bke3zdl4">
                {allRoutes.map(route => <li key={route.to} data-id="element-242" data-mp="fudfxlogkuzk">
                    <Link to={route.to} className="inline-block py-0.5 font-sans text-[15px] text-white transition-colors hover:text-brand-yellow" data-id="element-243" data-mp="fxhrx5860v0s">
                      {route.label}
                    </Link>
                  </li>)}
              </ul>
            </nav>

            <nav aria-label="Footer connect links" data-id="element-244" data-mp="219t38vcyf38d">
              <h2 className="font-meta text-xs font-semibold uppercase tracking-[0.18em] text-brand-blue" data-id="element-245" data-mp="28s0n5f3p6cw6">
                Connect
              </h2>
              <ul className="mt-4 space-y-3" data-id="element-246" data-mp="2dpsp71y23fe3">
                {connectLinks.map(link => <li key={link.label} data-id="element-247" data-mp="2ij52wh1761s2">
                    <a href={link.href} target="_blank" rel="noopener noreferrer" className="inline-block py-0.5 font-sans text-[15px] text-white transition-colors hover:text-brand-yellow" data-id="element-248" data-mp="2ik6fipxv2wbw">
                      {link.label}
                      <NewTabHint data-id="element-249" data-mp="1zr2tnqqvxnru" />
                    </a>
                  </li>)}
              </ul>
            </nav>
          </div>
        </Reveal>

        <p className="mt-12 font-meta text-[13px] text-white" data-id="element-250" data-mp="23ql57vwtgmi0">
          © {year} UCF Baptist Collegiate Ministries
        </p>
      </div>
    </footer>;
}